/* eslint camelcase: 0 */
import common from './common/ru_RU';
import dappsMaker from './dapps-maker/ru_RU';
import dappsSubmission from './dapps-submission/ru_RU';
import home from './home/ru_RU';
import footer from './footer/ru_RU';
import gettingStarted from './getting-started/ru_RU';
import privacyPolicy from './privacy-policy/ru_RU';
import termsOfService from './terms-of-conditions/ru_RU';
import accessWallet from './access-wallet/ru_RU';
import interfaceTranslations from './interface/ru_RU';
import errorsGlobal from './errors-global/ru_RU';
import trezorError from './errors-trezor/ru_RU';
import ledgerError from './errors-ledger/ru_RU';
import keepkeyError from './errors-keepkey/ru_RU';
import bitboxError from './errors-bitbox/ru_RU';
import buyHardwareWallet from './other/buy-hardware-wallet/ru_RU';
import convertUnits from './other/convert-units/ru_RU';
import verifyMessage from './other/verify-message/ru_RU';
import sendTx from './send-tx/ru_RU';
import ens from './dapps-ens/ru_RU';
import subDomain from './dapps-sub-domain/ru_RU';
import scheduleTx from './dapps-schedule-tx/ru_RU';
import nftManager from './nft-manager/ru_RU';
import signMessage from './sign-message/ru_RU';
import dappsAmbrpay from './dapps-ambrpay/ru_RU';
import phishing from './other/phishing/ru_RU';
import header from './header/ru_RU';
import dappsMCDMaker from './dapps-mcd-maker/ru_RU';

const ru_RU = {
  common: common,
  home: home,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfService: termsOfService,
  accessWallet: accessWallet,
  interface: interfaceTranslations,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  ledgerError: ledgerError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError,
  buyHardwareWallet: buyHardwareWallet,
  dappsMaker: dappsMaker,
  convertUnits: convertUnits,
  verifyMessage: verifyMessage,
  sendTx: sendTx,
  ens: ens,
  subDomain: subDomain,
  scheduleTx: scheduleTx,
  nftManager: nftManager,
  signMessage: signMessage,
  dappsSubmission: dappsSubmission,
  dappsAmbrpay: dappsAmbrpay,
  phishing: phishing,
  header: header,
  dappsMCDMaker: dappsMCDMaker
};
export default ru_RU;
